import userArea from '@/views/account/userArea'

export default [
  {
    path: '/conta',
    name: 'userArea',
    component: userArea,
    meta: {
      layout: 'sidebar',
      heading: 'menu.account',
      auth: true
    }
  }
]